import { actions as CommonActions } from "@tailormed/common-client/store/action";

export const trackPendoEvent = (dispatch, eventName, eventData = {}) => {
  const { sendPendoEvent } = CommonActions;
  const appVersion = process.env.REACT_APP_VERSION;

  dispatch(sendPendoEvent(eventName, { app_version: appVersion, ...eventData }));
};

export const identifyPendoUser = (user, account) => {
  try {
    // initially user is anonymously initialized in login.js
    // we identify user after login to merge the anonymous user with the logged in user
    if (user && account && window.pendo && window.location.hostname !== "localhost") {
      window.pendo.identify({
        visitor: {
          id: user.email,
          phoneNumber: user.phoneNumber,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          oktaId: user.id
        },
        account: {
          id: account,
          name: account
        }
      });
    }
  } catch (error) {
    console.error(`Failed to identify Pendo user.`, error);
  }
};

export default { trackPendoEvent, identifyPendoUser };
